import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';

import { WindowService } from '@cigna/core/window';

import { Action } from '@ngrx/store';

import {
  LoginActionTypes,
  LoginSubmit,
  LoginSuccess,
  LoginError,
} from './login.actions';

import { Observable, of } from 'rxjs';
import { map, switchMap, catchError, tap } from 'rxjs/operators';

import { LoginService } from '../data/login.service';

import { Router } from '@angular/router';

@Injectable()
export class LoginEffects {
  constructor(
    private actions$: Actions,
    private loginService: LoginService,
    private router: Router,
    private _window: WindowService,
  ) {}

  submitLogin$: Observable<Action> = createEffect(() =>
    this.actions$.pipe(
      ofType(LoginActionTypes.LoginSubmit),
      map((action: LoginSubmit) => action.payload),
      switchMap((data) =>
        this.loginService.login(data.username, data.password).pipe(
          map((location: string) => new LoginSuccess(location)),
          catchError((_err) => of(new LoginError())),
        ),
      ),
    ),
  );

  loginSuccess$ = createEffect(
    () =>
      this.actions$.pipe(
        ofType(LoginActionTypes.LoginSuccess),
        map((action: LoginSuccess) => action.payload),
        tap((location) => {
          if (location.includes('/app')) {
            this.router.navigate([location.replace('/app', '')]);
          } else {
            this._window.location.href = location;
          }
        }),
      ),
    { dispatch: false },
  );
}
